import React from 'react';

import GameModeModal from '~/components/GameModesModals/GameModeModal';
import Icon from '~/components/Icon';
import { useAuth } from '~/contexts/AuthContext';

interface MultiplayerModeModalProps {
  onClose: () => void;
}

function MultiplayerModeModal({ onClose }: MultiplayerModeModalProps) {
  const { isAuthenticated } = useAuth();

  return (
    <GameModeModal
      dataCy="multiplayer-mode-modal"
      title="MULTIPLAYER MODE"
      modeLabel="Multiplayer Mode"
      ctaTo="/arcade/config/multiplayer"
      onClose={onClose}
    >
      <div className="flex flex-col gap-2">
        <p className="mb-4">
          Challenge your friends and prove who's the ultimate gaming expert.
        </p>
        <div className="flex items-center gap-3">
          <Icon name="star" size={6} className="text-yellow-500" />
          <p>
            <span>Go head-to-head with friends</span>
          </p>
        </div>

        <div className="flex items-center gap-3">
          <Icon name="star" size={6} className="text-yellow-500" />
          <p>
            <span>Create your own party or join someone else</span>
          </p>
        </div>

        <div className="flex items-center gap-3">
          <Icon name="star" size={6} className="text-yellow-500" />
          <p>
            <span>Same riddles, same chances - pure skills</span>
          </p>
        </div>
      </div>

      <p>
        <span>
          Face off in head-to-head battles through immersive 360° panoramas,
          strategic screenshots, iconic sound effects, and gameplay videos..
        </span>
      </p>

      <p>
        <span>
          Everyone gets the same riddles - but only one can claim victory.
        </span>
      </p>

      <div>
        {isAuthenticated && (
          <div className="flex justify-between bg-gray-300 py-4 px-4 rounded-2xl backdrop-blur-2xl">
            Want to play with a friend ? Ask him/her to share the invitation
            link with you.
          </div>
        )}
      </div>
    </GameModeModal>
  );
}

export default MultiplayerModeModal;
